
<div>
  <RDECatalogTable
    showExpand
    :headers="headers"
    :items="extensionPackages"
    item-key="name"
    singleExpand
  >
    <template #toolbar>
      <div class="flex justify-end mb-2">
        <Button
          fill
          color="primary"
          class="normal-case"
          size="md"
          @click="openPopup"
        >
          <v-icon class="mr-1">mdi-plus</v-icon>
          Add
        </Button>
      </div>
    </template>
    <template #expanded-item="{ item }">
      <RDEChildTable :items="item.extensions" :headers="extensionHeaders">
        <template v-slot:[`item.created`]="{ item }">
          {{ item.created | formatDate }}
        </template>
      </RDEChildTable>
    </template>
    <template v-slot:[`item.created`]="{ item }">
      {{ item.created | formatDate }}
    </template>
    <template v-slot:[`item.action`]="{ item }">
      <div class="flex justify-center gap-2">
        <v-icon
          class="cursor-pointer"
          @click="() => editExtensionPackage(item)"
        >
          mdi-pencil
        </v-icon>
      </div>
    </template>
  </RDECatalogTable>
  <Dialog
    :value="isOpenPopup"
    persistent
    :title="defaultEditValue ? 'Edit Package' : 'Create Package'"
    max-width="800"
    min-height="700"
    @input="(value) => (!value ? closePopup() : (isOpenPopup = true))"
  >
    <ExtensionPackagePopup
      v-if="isOpenPopup"
      :closePopup="closePopup"
      :reloadData="fetchExtensionPackage"
      :defaultEditValue="defaultEditValue"
    />
  </Dialog>
</div>
